import { getNonconfigurableOrderPartConfigInfo_getNonconfigurableOrderPartConfigInfo as NonconfigurableOrderPartConfigInfoType } from './__generated__/getNonconfigurableOrderPartConfigInfo'

export function formatNonConfigurableInfo(
    nonConfigurableInfo: NonconfigurableOrderPartConfigInfoType[],
) {
    return nonConfigurableInfo
        .map((part: NonconfigurableOrderPartConfigInfoType) => part.fileName)
        .join(', ')
}
